import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBean: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBean"><Path d="M19.418 4.58202C22.6955 7.85949 22.0312 13.8375 17.9344 17.9344C13.8375 22.0312 7.85949 22.6955 4.58202 19.418C1.30455 16.1405 1.96878 10.1625 6.06562 6.06562C10.1625 1.96878 16.1405 1.30455 19.418 4.58202Z" stroke="currentColor"/><Path d="M3.87891 17.9998C8.12613 9.73933 15.868 14.2568 20.1189 6.00977" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBean;
